import { registerAction } from '../../Action'

const REGISTER_SHROUD_VISIBLE = 'REGISTER_SHROUD_VISIBLE'

const reducer = (state = {}, action) => ({
  ...state,
  isShroudVisible: action.payload,
})

const registerShroudVisible = registerAction(REGISTER_SHROUD_VISIBLE, {
  reducer,
})

export default registerShroudVisible
